import { render } from "./AdminMeldeliste.vue?vue&type=template&id=82fa6624&scoped=true"
import script from "./AdminMeldeliste.vue?vue&type=script&lang=js"
export * from "./AdminMeldeliste.vue?vue&type=script&lang=js"

import "./AdminMeldeliste.vue?vue&type=style&index=0&id=82fa6624&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82fa6624"]])

export default __exports__